<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" v-show="showSearch" label-width="85px">
      <el-row :gutter="10" class="mb8">
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="合同编号" prop="contractNum">
            <el-input v-model="queryParams.contractNum" placeholder="请输入合同编号" clearable/>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="客户名称" prop="customerNameReg">
            <el-input v-model="queryParams.customerNameReg" placeholder="请输入客户名称" clearable/>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="开票时间" prop="invoiceDate">
            <el-date-picker v-model="queryParams.invoiceDate" value-format="yyyy-MM-dd" type="daterange" range-separator="-" style="width:100%" start-placeholder="开始日期" end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="创建时间" prop="createTime">
            <el-date-picker v-model="queryParams.createTime" value-format="yyyy-MM-dd" type="daterange" range-separator="-" style="width:100%" start-placeholder="开始日期" end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="24" :lg="24" align="right">
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>

    <el-row style="margin: 10px 0;">
      <el-col :span="24">
        <div style="font-size: 14px; margin: 5px 0">
          <span>开票总额（元）：{{ amountFormat(Number(otherData.totalInvoiceAmount || 0) / 10000) }}万</span>
        </div>
      </el-col>
    </el-row>

    <el-table v-loading="loading" :data="dataList">
      <el-table-column label="发票号码" min-width="190" align="center" prop="invoiceNum" fixed="left" show-overflow-tooltip />
      <el-table-column label="合同编号" min-width="150" align="center" fixed="left">
        <template slot-scope="scope">
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toContractDetail(scope.row)">{{scope.row.contractNum}}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="客户名称" min-width="180" align="center" fixed="left">
        <template slot-scope="scope">
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toCustomerDetail(scope.row)">{{scope.row.customerName}}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="开票抬头" width="150" align="center">
        <template slot-scope="scope">
          <el-link type="primary" class="crm-link-wrap" :underline="false" @click="toDetail(scope.row)">{{scope.row.invoiceTitle}}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="抬头类型" width="100" align="center" prop="titleTypeDesc"/>
      <el-table-column label="开票类型" width="100" align="center" prop="invoiceCreateTypeDesc"/>
      <el-table-column label="发票类型" width="130" align="center" prop="invoiceTypeDesc"/>
      <el-table-column label="税号" min-width="150" align="center" prop="companyTaxNum"/>
      <el-table-column label="开票金额(元)" width="100" align="center">
        <template slot-scope="scope">
          <span>{{ amountFormat(scope.row.invoiceAmount) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="开票时间" width="100" align="center" prop="invoiceDate"/>
      <el-table-column label="创建人" width="80" align="center" prop="createUserName"/>
      <el-table-column label="创建时间" width="170" align="center" prop="createTime" />
      <el-table-column label="操作" width="150" align="center" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="text" icon="el-icon-edit" @click="toEdit(scope.row)">编辑</el-button>
          <el-button type="text"  @click="handleFollow(scope.row)">跟进</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="getList"/>

    <AssignDialog ref="assignDialogRef" @success="getList"></AssignDialog>
    <FollowAddDialog ref="followAddDialogRef" @success="getList"></FollowAddDialog>
  </div>
</template>

<script>
import { pageContractInvoice } from "@/api/crm/invoice";
import UserSelect from "@/views/crm/components/userSelect";
import AssignDialog from "@/views/crm/components/assignDialog";
import FollowAddDialog from "@/views/crm/follow/followAddDialog";
import { mapState } from 'vuex'
import { amountFormat } from '@/utils/index'

export default {
  name: "InvoiceManage",
  data() {
    return {
      amountFormat,
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      statusOptions: [],
      // 总条数
      total: 0,
      dataList: [],
      otherData: {
        totalInvoiceAmount: 0
      },
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        contractNum: null,
        customerName: null,
        invoiceDate: [],
        createTime: []
      }
    };
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  components: {
    UserSelect,
    AssignDialog,
    FollowAddDialog
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      let params = JSON.parse(JSON.stringify(this.queryParams));
      if (params.createTime && params.createTime.length > 1) {
        params.createTimeStart = params.createTime[0]
        params.createTimeEnd = params.createTime[1]
      }
      params.createTime = undefined;
      if (params.invoiceDate && params.invoiceDate.length > 1) {
        params.invoiceDateStart = params.invoiceDate[0]
        params.invoiceDateEnd = params.invoiceDate[1]
      }
      params.invoiceDate = undefined;
      pageContractInvoice(params).then(response => {
          this.dataList = response.rows || [];
          this.otherData = response.otherData || { totalInvoiceAmount: 0 };
          this.total = response.total;
          this.loading = false;
        }
      ).catch(error => {
        this.loading = false;
      });
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.queryParams.managerId = null;
      this.handleQuery();
    },
    /** 详细按钮操作 */
    toDetail(row) {
      window.open("/crm/invoice/detail/" + row.id, "_blank")
    },
    /** 编辑按钮操作 */
    toEdit(row) {
      window.open("/crm/invoice/detail/" + row.id + "?edit=1", "_blank")
    },
    /** 详细按钮操作 */
    toContractDetail(row) {
      window.open("/crm/contract/detail/" + row.contractId, "_blank")
    },
    /** 详细按钮操作 */
    toCustomerDetail(row) {
      window.open("/crm/customer/detail/" + row.customerId, "_blank")
    },
    /** 跟进按钮操作 */
    handleFollow(row) {
      this.$refs.followAddDialogRef.open("contractInvoice", row.id);
    },
    /** 分配按钮操作 */
    handleAssign() {
      this.$refs.assignDialogRef.batchAssign("contractInvoice", this.ids);
    }
  }
};
</script>
